"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_healthy__living(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab14c4fa-c00e-41ce-88c4-6517f13eff29",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "main_icn_Favourites"), /*#__PURE__*/React.createElement("path", {
    id: "4561f1ce-92d7-4fb8-9f06-11f449d2aab9",
    "data-name": "<Pfad>",
    d: "M100.65,49.25A41.54,41.54,0,0,0,94.83,37.4,41,41,0,0,0,61.35,20C38.64,20,18.54,38.62,20.06,61.48,23.61,114.85,96,172,96,172c80.2-63.78,75.94-109.53,75.94-109.53,0-22.91-17.5-42.47-40.21-42.47-6.85,0-24,2.19-34.63,21",
    transform: "translate(-15.98 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_healthy__living;
exports.default = _default;